// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 363 ? "cff4c5fa" : chunkId) + "." + {"363":"4b872e57e01a2873","516":"741ce3ee3ae8ac02"}[chunkId] + ".js";
};